export default "__VITE_ASSET__fP5W8309__"